import { render } from "./ResultMark.vue?vue&type=template&id=af6fb1c2&ts=true"
import script from "./ResultMark.vue?vue&type=script&lang=ts"
export * from "./ResultMark.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__